export interface FireMetricModel {
  ag: string[];
  d: number;
  hr: string;
  singleHr: string;
  rg: number;
  val: number;
  ver: string;
  gmc: number;
  map?: string;
}

export default class FireMetric {
  ag: string[];
  d: number;
  hr: string;
  singleHr: string;
  map?: string;
  rg: number;
  val: string;
  ver: string;
  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   */
  gmc: number;

  constructor({ ag, d, hr, singleHr, map, rg, val, ver, gmc }: FireMetricModel) {
    this.ag = ag;
    this.d = d;
    this.hr = hr;
    this.singleHr = singleHr;
    this.map = map;
    this.rg = rg;
    this.val = val.toFixed(2);
    this.ver = ver;
    this.gmc = gmc;
  }
}
